import { render, staticRenderFns } from "./studentExamination.vue?vue&type=template&id=7ffa8390&scoped=true&"
import script from "./studentExamination.vue?vue&type=script&lang=js&"
export * from "./studentExamination.vue?vue&type=script&lang=js&"
import style0 from "./studentExamination.vue?vue&type=style&index=0&id=7ffa8390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffa8390",
  null
  
)

export default component.exports